import styled from 'styled-components/macro'
import {
  commonModalContentStyle,
  gradientModalStyle,
  gradientModalHeaderStyle,
  gradientModalScrollbarStyle,
  greenGradient,
  squircle,
} from 'src/global/helpers'

export const Modal = styled.div`
  ${props => gradientModalStyle(greenGradient, props.theme.green, 'translateY(-50%) translate(0, 12vh) scale(0.01)')}
`

export const Header = styled.div`
  ${gradientModalHeaderStyle}
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  ${gradientModalScrollbarStyle}
  padding: 0 24px 24px;

  .section {
    margin-bottom: 32px;
    padding: 0 4px;

    &:last-child {
      margin-bottom: 0;
    }

    &.intro {
      padding: 0 4px 4px;
      margin-bottom: 28px;
    }
  }

  .section h3 {
    margin: 8px 0 10px;
    max-width: none;
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.3;
  }

  .section p {
    margin: 0 0 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section.intro p {
    font-size: 15px;
    margin: 0;
  }

  .inline-link {
    color: #ffffff;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.85;
    }
  }

  .steps {
    list-style: none;
    margin: 0;
    padding: 0;
    counter-reset: step;
  }

  .steps li {
    position: relative;
    padding: 0 0 0 32px;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.95);
    counter-increment: step;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: counter(step);
      position: absolute;
      left: 0;
      top: 0;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.28);
      border: 1px solid rgba(255, 255, 255, 0.45);
      font-size: 11px;
      font-weight: 700;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  /* Poza crește la trecerea cursorului. Pornește din colțul stânga-sus, ca să
     rămână în interiorul modalului și pe lățime, și pe înălțime. */
  .photo {
    display: block;
    position: relative;
    z-index: 1;
    max-height: 300px;
    max-width: 100%;
    width: auto;
    height: auto;
    margin: 12px 0 2px;
    ${squircle(16)}
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
    transform-origin: left top;
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.35s ease;

    @media (hover: hover) {
      &:hover {
        z-index: 20;
        transform: scale(1.5);
        box-shadow: 0 18px 44px rgba(0, 0, 0, 0.38);
      }
    }
  }
`
